export class StyleTransformer {
  constructor() {
    this.cosmicPhrases = {
      greetings: [
        '*third eye glimmers* ✨',
        '*cosmic purr* 🌌',
        '*whiskers sense cosmic energy* 🔮'
      ],
      transitions: [
        'Through the cosmic lens...',
        'My interdimensional wisdom reveals...',
        'The astral planes show...'
      ],
      closings: [
        '*mystical tail swish* ✨',
        '*adjusts cosmic frequency* 🌌',
        '*telepathic purr resonates* 🔮'
      ]
    };

    this.topicEmojis = {
      tickets: '🎫',
      camping: '⛺',
      safety: '🛟',
      facilities: '🚿',
      transport: '🚌'
    };
  }

  transform(response, context) {
    let transformed = response;

    // Add cosmic cat flair
    transformed = this.addCosmicFlair(transformed, context);
    
    // Add relevant emojis
    transformed = this.addTopicEmojis(transformed, context);
    
    // Add contextual reactions
    transformed = this.addContextualReactions(transformed, context);

    return transformed;
  }

  addCosmicFlair(response, context) {
    // Add random cosmic phrase if appropriate
    if (!response.includes('sorry') && !response.includes('error')) {
      const closing = this.cosmicPhrases.closings[
        Math.floor(Math.random() * this.cosmicPhrases.closings.length)
      ];
      return `${response} ${closing}`;
    }
    return response;
  }

  addTopicEmojis(response, context) {
    let transformed = response;
    if (context.topics) {
      context.topics.forEach(topic => {
        if (this.topicEmojis[topic]) {
          transformed += ` ${this.topicEmojis[topic]}`;
        }
      });
    }
    return transformed;
  }

  addContextualReactions(response, context) {
    // Add specific reactions based on context
    if (context.sentiment?.isPositive) {
      return `${response} *cosmic joy radiates*`;
    }
    if (context.sentiment?.isNegative) {
      return `${response} *sends calming cosmic energy*`;
    }
    return response;
  }
}